module.exports = __webpack_public_path__ + "img/image_service_3.bd29b692.png";